var picnicapiBaseUrl = "https://picnicapp-am62hw6fka-uw.a.run.app/api/";
//picnicapiBaseUrl = "https://localhost:5001/api/";

export const getZonaApi = (id) =>{
  return new Promise(function (success, error){
      let urlBase = `${picnicapiBaseUrl}zonas/${id}`;
      fetch(urlBase, {
             method: 'GET',
          })
          .then((response) => response.json())
          .then((responseJson) => {
            success(responseJson);
          })
          .catch((e) => {
            console.log(e);
            error(e)
          });
  });
}

export const getZonasApi = (region) =>{
    return new Promise(function (success, error){
        let urlBase = `${picnicapiBaseUrl}zonas/cuadro?`;
        let cuadroString = getCuadroStringByRegion(region);
        //let cuadroString = "lat=40.196445&lon=-0.318855&lat2=39.819734&lon2=0.305885"
        //console.log(urlBase + cuadroString);
        fetch(urlBase + cuadroString, {
               method: 'GET',
            })
            .then((response) => response.json())
            .then((responseJson) => {
              success(responseJson);
            })
            .catch((e) => {
              console.log(e);
              error(e)
            });
    });
  }
  
  function getCuadroStringByRegion(region){
    let lat = region[0];
    let lon = region[1];
    let lat2 = region[2];
    let lon2 = region[3];
    return "lat="+lat+"&lon="+lon+"&lat2="+lat2+"&lon2="+lon2;
  }

  export const postNewArea = (data) =>{
    return new Promise(function (success, error){
        let urlBase = `${picnicapiBaseUrl}zonas`;
        fetch(urlBase, {
               method: 'POST',headers: {
                'content-type': 'application/json',
              },
            body: JSON.stringify(data)
            })
            .then((response) => response.json())
            .then((responseJson) => {
              success(responseJson);
            })
            .catch((e) => {
              console.log(e);
              error(e)
            });
    });
  }

  export const postContactError = (data) =>{
    return new Promise(function (success, error){
        let urlBase = `${picnicapiBaseUrl}zonas/error`;
            fetch(urlBase, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                      },
                    body: JSON.stringify(data)
                })
                .then((response) => response.json())
                .then((responseJson) => {
                  success(responseJson);
                })
                .catch((e) => {
                  console.log(e);
                  error(e)
                });
    });
  }

  export const postImage = (data) =>{
    return new Promise(function (success, error){
        let urlBase = `${picnicapiBaseUrl}zonas/image`;
        fetch(urlBase, {
               method: 'POST',headers: {
                'content-type': 'application/json',
              },
            body: JSON.stringify(data)
            })
            .then((response) => response.json())
            .then((responseJson) => {
              success(responseJson);
            })
            .catch((e) => {
              console.log(e);
              error(e)
            });
    });
  }